function safeStr(v) {
  return v == null ? "" : String(v).trim();
}

function normalizeWorkflow(workflow) {
  const raw = safeStr(workflow).toLowerCase().replace(/^workflow_/, "").replace(/^w/, "");
  if (raw === "1" || raw === "2" || raw === "3") return `wf${raw}`;
  return "";
}

function normalizeDay(day) {
  const value = safeStr(day);
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  return "";
}

function normalizeKey(key) {
  const value = safeStr(key);
  if (/^[A-Za-z0-9_-]+$/.test(value)) return value;
  return "";
}

export function makeStatusDayRoom(day) {
  const normalized = normalizeDay(day);
  return normalized ? `status:day:${normalized}` : null;
}

export function makeWorkflowAllRoom(workflow) {
  const wf = normalizeWorkflow(workflow);
  return wf ? `${wf}:all` : null;
}

export function makeWorkflowDayRoom(workflow, day) {
  const wf = normalizeWorkflow(workflow);
  const normalizedDay = normalizeDay(day);
  return wf && normalizedDay ? `${wf}:day:${normalizedDay}` : null;
}

export function makeWorkflowItemRoom(workflow, key) {
  const wf = normalizeWorkflow(workflow);
  const normalizedKey = normalizeKey(key);
  return wf && normalizedKey ? `${wf}:item:${normalizedKey}` : null;
}

export function makeEstaleiroDepositoRoom() {
  return "estaleiro:deposito";
}

export function makeCimInterdicoesRoom() {
  return "cim:interdicoescim";
}

export function makeEstaleiroLoteRoom(codigoLote) {
  const normalizedKey = normalizeKey(codigoLote);
  return normalizedKey ? `estaleiro:lote:${normalizedKey}` : null;
}
